module.exports = __webpack_public_path__ + "img/upcoming-events_us-open.34319a9d.jpg";